export const mutations = {
    setHistory(state, payload) {
        state.history = payload;
    },

};
